//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.EnumType
import kotlin.Array
import kotlin.Deprecated
import kotlin.String
import kotlin.collections.List

public enum class BunkerActivityDocumentType(
  public val rawValue: String,
) {
  MANDATORY("MANDATORY"),
  ADDITIONAL("ADDITIONAL"),
  SUPPORTING("SUPPORTING"),
  /**
   * Auto generated constant for unknown enum values
   */
  UNKNOWN__("UNKNOWN__"),
  ;

  public companion object {
    public val type: EnumType =
        EnumType("BunkerActivityDocumentType", listOf("MANDATORY", "ADDITIONAL", "SUPPORTING"))

    /**
     * All [BunkerActivityDocumentType] known at compile time
     */
    public val knownEntries: List<BunkerActivityDocumentType>
      get() = listOf(
        BunkerActivityDocumentType.MANDATORY,
        BunkerActivityDocumentType.ADDITIONAL,
        BunkerActivityDocumentType.SUPPORTING)

    /**
     * Returns all [BunkerActivityDocumentType] known at compile time
     */
    @Deprecated(
      message = "Use knownEntries instead",
      replaceWith = ReplaceWith("this.knownEntries"),
    )
    public fun knownValues(): Array<BunkerActivityDocumentType> = knownEntries.toTypedArray()

    /**
     * Returns the [BunkerActivityDocumentType] that represents the specified [rawValue].
     * Note: unknown values of [rawValue] will return [UNKNOWN__]. You may want to update your schema instead of calling this function directly.
     */
    public fun safeValueOf(rawValue: String): BunkerActivityDocumentType = entries.find { it.rawValue == rawValue } ?: UNKNOWN__
  }
}
